export default {
  menuAdmin: 'menu managerment',
  menuList: 'menu list',
  addMeun: 'add menu',

  table: {
    menuName: 'menu name',
    menuNameVn: 'vietnamese menu name',

    menuNameEn: 'Menu name in English',
    menuCode: 'menu code',
    menuGrade: 'menu level',
    menuParent: 'main menu code',
    menuParentName: 'second menu name',
    menuStatus: 'menu status',
    autoTransIn: 'Auto transfer in',
    menuUrl: 'menuURL',
    apiUrl: 'menu apiurl',
    compileMenu: 'edit menu',
    addMenu: 'add menu',
    sort: 'sort'
  },

  data: {
    LevelOnemenu: 'menu level 1',
    LevelTwomenu: 'menu level 2',
    LevelThreebutton: 'menu level 3',
    checkmenuGrade: 'Please select menu level',
    checkmenuCode: 'Please enter the menu code',
    checkmenuName: 'Please enter the menu name',
    checkmenuNameVn: 'Please enter the menu name in Vietnamese',
    checkmenuNameEn: 'Please enter the menu name in English',

    menuUrl: 'please enter menu url',
    apiUrl: 'please enter menu apiUrl',
    addMenuSucceed: 'add menu success',
    addMenuError: 'add menu failed',
    changMenuSucceed: 'modify menu success',
    changMenuError: 'modify menu failed',
    sort: 'sort failed'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/menumanage.js